<template>
    <main>
        <DialogPromotionModeration @updated="onUpdatedEvent" @openNext="moderateNext" ref="promotionModDialog"/>
        <v-table
            id="mainTbl"
            request-uri="promotions/getList"
            pagesize="50"
            ref="table"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="clinicName" width="400">
                        Клиника
                    </v-th>
                    <v-th name="name" sort="name" minwidth="200">
                        Название
                    </v-th>
                    <v-th name="promotionsActivity" width="75">
                        Период
                    </v-th>
                    <v-th name="discount" width="75">
                        Скидка
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="clinicName" :debounce="true" v-slot="{filter}" width="400">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="promotionsActivity" v-slot="{filter}" width="75">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                   value: "willBegin",
                                   text: "Запланирована"
                                },
                                                        {
                                   value: "active",
                                   text: "Активна"
                                },
                                {
                                    value: "ended",
                                    text: "Закончилась"
                                },
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="discount" v-slot="{filter}" width="75">
                        <v-input v-model="filter.value"/>
                    </v-th>

                </v-tr>

            </template>

            <template v-slot:row="{ item, index, indexOnPage }">
                <v-tr :class="['hover', 'pointer', {'warning': !item.approved}]" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="clinicName" width="400">
                        <div v-for="clinic in item.clinics" :class="[{'warning': clinic.isModerationSource}]">
                            <div class="text-ellipsis">
                                {{clinic.name}}
                            </div>
                        </div>
                        <div v-for="network in item.networkModerationSources" class="warning">
                            <div class="text-ellipsis">
                                Сетевой Аккаунт ({{network.name}})
                            </div>
                        </div>
                    </v-td>
                    <v-td name="name">
                        <span>{{ item.name }}</span>
                    </v-td>
                    <v-td name="promotionsActivity" highlight="*" width="75">
                        {{item.dateFrom | formatDatePeriodShort(item.dateTill) }}
                    </v-td>
                    <v-td name="discount" highlight="*" width="75" align="center">
                        <span>{{ item.discount? item.discount+' %': '-' }}</span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>
<script>
import DialogPromotionModeration from './Dialog'
export default {
    components: { DialogPromotionModeration },
    methods: {
        onUpdatedEvent (){
            this.$refs.table.update();
        },
        handleRowClick(event, row, item) {
            row.startLoadingAnimation();
            this.$refs.promotionModDialog
                .showModal(item.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
        moderateNext(promoId) {
            setTimeout(async () => {
                let previousPromoId = promoId;
                let row, index;

                for (const i in this.$refs.table.rows) {
                    index = parseInt(i);
                    row = this.$refs.table.rows[index];

                    if (row.id === previousPromoId && this.$refs.table.rows[index + 1] && this.$refs.table.rows[index + 1].id) {
                        await this.axios.get('/admin/moderation/promotions/' + this.$refs.table.rows[index + 1].id + '/isOpened')
                            .then(data => {
                                if (data.data.success) {
                                    const nextRow = document.querySelectorAll('#mainTbl table tbody tr.table-row')[index + 1];
                                    if (nextRow) {
                                        nextRow.click();
                                    }
                                }else {
                                    previousPromoId = this.$refs.table.rows[index + 1].id;
                                }
                            })
                    }
                }

                this.$refs.table.update();
            }, 1000);
        },
    },
}
</script>
<style>

</style>
